import { render, staticRenderFns } from "./MStar.vue?vue&type=template&id=35a7790f&scoped=true"
import script from "./MStar.vue?vue&type=script&lang=js"
export * from "./MStar.vue?vue&type=script&lang=js"
import style0 from "./MStar.vue?vue&type=style&index=0&id=35a7790f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a7790f",
  null
  
)

export default component.exports